import { render, staticRenderFns } from "./3DVisualisation.vue?vue&type=template&id=733a79a6&"
import script from "./3DVisualisation.vue?vue&type=script&lang=js&"
export * from "./3DVisualisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports